export enum ScrollDepthPageName {
  HOME = 'home_page',
  REGIMEN_UNPAID = 'regimen_unpaid',
  REPORT = 'report',
}

export interface ScrollDepthInitOptions {
  bottomInsetPx?: number;
}
